// import './index.less';
// import { CarouselFrontend } from './component/carousel/carousel-frontend';
// import { CarouselUniversalFrontend } from './component/carousel-universal/carousel-universal-frontend';
//import { YoutubeFrontend } from './component/youtube/youtube-frontend';
//import { BlogSearchCommon } from './blog/blog-search';
//import { SiteSearchCommon } from './site-search/site-search';
import { FormCommon } from './component/form-components/form/form-common';
//import { ImageCommon } from './component/image/image-common';
//import { AccordionCommon } from './component/accordion/accordion-common';
import { RepeatableFieldGroupFrontend } from './component/form-components/simple/repeatable-field-group/repeatable-field-group-frontend'
import {iframeFrontend} from "./component/iframe/iframe-frontend";



//ImageCommon.init();
// CarouselFrontend.init();
// CarouselUniversalFrontend.init();
//YoutubeFrontend.init();
//SiteSearchCommon.init();
FormCommon.initForms();
//AccordionCommon.initAll();
//BlogSearchCommon.init();
RepeatableFieldGroupFrontend.init();
iframeFrontend.init();
